module.exports = __webpack_public_path__ + "static/img/be_overdue.ce626ef.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/be_overdue.png
// module id = tglQ
// module chunks = 1